'use client'
import { ToPageButton } from '@/app/ui/parts/default/sp/parts/buttons/toPageButton'
import { articleCategoryType } from '@/lib/article/server'
import { serviceType } from '@/lib/service/server'
import { useEffect, useState } from 'react'

export const ArticleBottomCategoryButton = ({
  service,
  category,
}: {
  service: serviceType
  category: articleCategoryType
}) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset
      setIsVisible(scrollY > 200)
    }

    // スクロールイベントリスナーを追加
    window.addEventListener('scroll', handleScroll)

    // クリーンアップ関数
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  if (!isVisible) return null
  return (
    <div
      className="fixed bottom-0 left-0 text-center w-full bg-white"
      style={{ zIndex: 30 }}
    >
      <ToPageButton
        text={`${service.prefix} ${category.name}の一覧を見る`}
        href={`/category/${category.category_id}`}
      />
    </div>
  )
}
